import Component from 'components/component'
import Tooltip from 'components/tooltip'
import { DI } from 'modules'
import React, { Fragment } from 'react'
import * as config from 'config'

export class ChoosePlanColumn extends Component {
  static defaultProps = {
    calcMaxHeight(h) {},
  }

  componentDidMount() {
    if (document.readyState === 'complete') {
      this.height = this.bottom.clientHeight
      this.props.calcMaxHeight(this.bottom.clientHeight)
    } else {
      window.addEventListener('load', () => {
        this.height = this.bottom.clientHeight
        this.props.calcMaxHeight(this.bottom.clientHeight)
      })
    }
  }

  render() {
    const mod = 50

    return (
      <div className={`choose-plan-plan choose-plan-plan--${mod}`}>
        <div className="choose-plan-plan-inner">
          <div className="choose-plan-plan-inner-top">
            <span className="choose-plan-plan__title">{this.props.title}</span>
            <div className="choose-plan-plan-text">
              <p>{this.props.text}</p>
            </div>
            <div className="choose-plan-plan-info j-plan-column-info">
              <PlanInfo
                modals={this.props.modals || {}}
                items={this.props.info}
                or={
                  this.props.common.strings[
                    'page.payment.licence.requirement.or'
                  ]
                }
              />
            </div>
          </div>
          <div
            className="choose-plan-plan-inner-bottom"
            ref={el => (this.bottom = el)}
            style={{ height: this.height ? this.props.height : 'auto' }}
          >
            <div className="choose-plan-plan-formats">
              {this.props.mp4 && (
                <PlanFormat color="blue" name="Full HD" type="mp4" />
              )}
              {this.props.mxf && (
                <PlanFormat color="purple" name="Full HD" type="mxf" />
              )}
            </div>
            {this.props.bottom}
          </div>
        </div>
      </div>
    )
  }
}

export class PlanInfo extends Component {
  static defaultProps = {
    items: [],
  }

  renderStringWithTooltips(string) {
    const matchRegExp = /({{([^}}])*}})/gi
    const replaceRegExp = /[({{)(}})]/g
    let tooltips = string.match(matchRegExp) || []

    tooltips.forEach(item => {
      string = string.replace(item, '$tooltip')
    })
    string = string.split('$tooltip')

    return string.map((part, index) => (
      <Fragment key={part}>
        {part}
        {tooltips[index] && (
          <Tooltip content={tooltips[index].replace(replaceRegExp, '')}>
            <span className="question" />
          </Tooltip>
        )}
      </Fragment>
    ))
  }
  render() {
    return (
      <ul>
        {this.props.items.map((item, index) => {
          if (typeof item === 'string') {
            return <li key={index}>{this.renderStringWithTooltips(item)}</li>
          }

          if (item instanceof Array) {
            return (
              <li key={index}>
                {item.map((subitem, index) => {
                  let rendered = null

                  if (typeof subitem === 'string') {
                    rendered = <p>{this.renderStringWithTooltips(subitem)}</p>
                  }

                  if (typeof subitem === 'object') {
                    switch (subitem.type) {
                      case 'ModalButton': {
                        rendered = (
                          <p>
                            <a
                              rel={subitem.modal}
                              href="#"
                              onClick={this.props.modals[subitem.modal]}
                            >
                              {subitem.title}
                            </a>
                          </p>
                        )
                        break
                      }
                      case 'Usage': {
                        rendered = (
                          <div className="choose-plan-var">
                            <p>
                              {this.renderStringWithTooltips(subitem.line1)}
                            </p>
                            <span className="choose-plan-var__or">
                              <span className="choose-plan-var__or-text">
                                {this.props.or}
                              </span>
                            </span>
                            <p>
                              {this.renderStringWithTooltips(subitem.line2)}
                            </p>
                          </div>
                        )
                        break
                      }
                      default: {
                        rendered = null
                      }
                    }
                  }

                  return <Fragment key={index}>{rendered}</Fragment>
                })}
              </li>
            )
          }

          return null
        })}
      </ul>
    )
  }
}

function PlanFormat(props) {
  return (
    <div
      className={`choose-plan-plan-format choose-plan-plan-format--${props.color}`}
    >
      <span className="choose-plan-plan-format__name">{props.name}</span>
      <span className="choose-plan-plan-format__type">{props.type}</span>
    </div>
  )
}

export default DI([])(ChoosePlanColumn)
